/**
 * ============================================================================
 * TaskFlow ERP
 * Module : Campaign Management
 * Feature: Prospect Import
 *
 * File:
 * src/modules/campaign/prospectImport/constants/importConfig.js
 * ============================================================================
 */

const importConfig = {

    module: "Campaign Management",

    feature: "Prospect Import",

    templateName: "Prospect Import",

    templateVersion: "1.0",

    supportedExtensions: [

        "xlsx",

        "xls",

        "csv"

    ],

    maxFileSizeMB: 10,

    instructions:
        "Import prospect data into TaskFlow ERP using the standard Excel template."

};

export default importConfig;